import { createIcon } from '@chakra-ui/react';

export const Plus = createIcon({
  displayName: 'Plus',
  viewBox: '0 0 20 20',
  path: (
    <g id="Group_3007" data-name="Group 3007" transform="translate(-15 -11)">
      <g
        id="Path_2372"
        data-name="Path 2372"
        transform="translate(15 11)"
        fill="none"
      >
        <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none" />
        <path
          d="M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
      <g
        id="Plus_Add_-_S"
        data-name="Plus Add - S"
        transform="translate(20 16)"
      >
        <path
          id="Plus_Add_-_S-2"
          data-name="Plus Add - S"
          d="M9.918,4.918H6.082V1.082a.582.582,0,1,0-1.164,0V4.918H1.082a.582.582,0,0,0,0,1.164H4.918V9.918a.582.582,0,1,0,1.164,0V6.082H9.918a.582.582,0,0,0,0-1.164Z"
          transform="translate(-0.5 -0.5)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
